import { Button, Divider, Flex, message, Space, Typography } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/pro-solid-svg-icons"
import { useContext } from "react"
import { ItemsContext } from "../../../Items/ItemsRoot"
import JobPlanContext from "../JobPlanContext"
import { getOverviewData } from "../List/workareaGroupsListModel"
import SavingIndicator from "./WorkareaEditor/SavingIndicator"
import { centsToDollarsDisplay } from "../../../displayFormatters"
import { useGetJobByIdQuery } from "../../jobsQueries"
import { GetJobByIdResponse } from "../../jobsApi"

const { Text, Title } = Typography

type Props = {
  isAutosaving: boolean
  isSaved: boolean
}

const GroupEditor = ({ isAutosaving, isSaved }: Props) => {
  const { workareaSummaries, jobData: { jobId } } = useContext(ItemsContext)
  const { clearSelection, isTotalsCalculating, setPendingAction } = useContext(JobPlanContext)
  const { estimatedHours, finalPrice } = getOverviewData(workareaSummaries)
  const getJobByIdQuery = useGetJobByIdQuery(jobId)
  const jobDetails = getJobByIdQuery.data ?? {} as GetJobByIdResponse

  const handleClose = () => {
    if (isTotalsCalculating) {
      message.loading('Waiting for totals calculations to complete...', 0)
      setPendingAction(() => () => {
        message.destroy()
        clearSelection()
      })
      return
    }
    clearSelection()
  }

  return <Flex
    style={{
      borderBottom: '1px solid #f0f0f0',
      backgroundColor: 'white',
      height: '64px',
      padding: '0 20px',
    }}
    justify="space-between"
    align="center"
  >
    <Space>
      <Title level={5} style={{ marginBottom: 0 }}>#{jobDetails.jobNo}</Title>
      <Title level={5} style={{ marginBottom: 0 }}>{jobDetails.jobName}</Title>
      <Title level={5} type="secondary" style={{ marginBottom: 0 }}>{jobDetails.customerName}</Title>
      <SavingIndicator isAutosaving={isAutosaving} isSaved={isSaved} />
    </Space>
    <Space>
      <Title level={5} style={{ margin: 0 }}>Total Estimated Hours: </Title>
      <Text style={{ margin: 0, fontSize: '14px' }}>{estimatedHours}h</Text>
      <Divider type="vertical" style={{ borderColor: "black" }} />
      <Title level={5} style={{ margin: 0 }}>Final Price: </Title>
      <Text style={{ margin: 0, fontSize: '14px' }}>{centsToDollarsDisplay(finalPrice)}</Text>
      <Button type="text" icon={<FontAwesomeIcon icon={faXmark} />} onClick={handleClose} />
    </Space>
  </Flex>
}

export default GroupEditor